import { render, staticRenderFns } from "./LpaHealth.vue?vue&type=template&id=45d05eb0"
import script from "./LpaHealth.vue?vue&type=script&lang=js"
export * from "./LpaHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports